import { Button, type IButtonProps } from "@similarweb/ui-components";

import { useTranslation } from "pro-features/components/WithTranslation";

import { CrmManagementDisabledTooltip } from "app/pages/sales-intelligence/common-components/CrmManagementDisabledTooltip";

import { MANAGEMENT_EXPORT_PREFERENCES_EDIT_BUTTON } from "../../../../common-components/export-table/translations";

type Props = Pick<IButtonProps, "isDisabled" | "onClick">;

const EditExportPreferencesButton = ({ isDisabled, onClick }: Props) => {
    const translate = useTranslation();

    const renderButton = (isReadOnly: boolean) => (
        <Button
            type="flat"
            isDisabled={isDisabled || isReadOnly}
            onClick={onClick}
            dataAutomation="manage-integration-edit-export-preferences-button"
        >
            {translate(MANAGEMENT_EXPORT_PREFERENCES_EDIT_BUTTON)}
        </Button>
    );

    return <CrmManagementDisabledTooltip renderContent={renderButton} />;
};

export default EditExportPreferencesButton;
